import { render, staticRenderFns } from "./rate-defaultValue-editor.vue?vue&type=template&id=1fc8e2ac&scoped=true"
import script from "./rate-defaultValue-editor.vue?vue&type=script&lang=js"
export * from "./rate-defaultValue-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc8e2ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fc8e2ac')) {
      api.createRecord('1fc8e2ac', component.options)
    } else {
      api.reload('1fc8e2ac', component.options)
    }
    module.hot.accept("./rate-defaultValue-editor.vue?vue&type=template&id=1fc8e2ac&scoped=true", function () {
      api.rerender('1fc8e2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-rate/rate-defaultValue-editor.vue"
export default component.exports